import { createFileRoute, redirect } from '@tanstack/react-router'
import { CorrectionRequestDetail } from '@/features/hr-attendance-corrections/correction-request-detail'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one attendance correction request.
 *
 * Same guard as the queue (`attendance.view`) — whether the caller may see
 * THIS request is the API's `EmployeeScope` answer, not the browser's; an
 * out-of-scope id comes back as an error the screen surfaces, not a redirect.
 *
 * Per the route-shell rule in `apps/company/AGENTS.md`, this file is a route
 * definition, a guard and a render.
 */
export const Route = createFileRoute('/_authenticated/hr/attendance-corrections/$requestId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'attendance.view')) {
      // A notification link reaches here without the grant: own requests live on the phone.
      throw redirect({ to: '/get-the-app' })
    }
  },
  component: RouteScreen,
})

function RouteScreen() {
  const { requestId } = Route.useParams()
  return <CorrectionRequestDetail requestId={requestId} />
}
